import React, {useState} from "react";
import {
    FlexibleWidthXYPlot,
    Hint,
    HorizontalGridLines,
    VerticalBarSeries,
    VerticalGridLines,
    XAxis,
    YAxis
} from 'react-vis';
import {Header} from "semantic-ui-react";

require('../../../node_modules/react-vis/dist/style.css')


export default function BalanceChart(props) {
        const {chartdata, year} = props
        const [value, setValue] = useState(false)

        const yDomain = chartdata.reduce(
            (res, row) => {
                return {
                    max: Math.max(res.max, row.y),
                    min: Math.min(res.min, row.y)
                };
            },
            {max: -Infinity, min: Infinity}
        );
        //difference bar chart
        const myData = chartdata.map((x, idx) => ({
            x: x.x,
            // if the bars are above zero then we start them at zero
            y0: (x.y > 0) ? 0 : 0+x.y,
            // if the bars are below zero then we stop them at zero
            y: (x.y < 0) ? 0 : x.y,
            color: x.color
        }));
        return (
            <div>
                <Header>Jahres Balance {year}</Header>
                <FlexibleWidthXYPlot height={300}
                                     margin={{left: 100}}
                                     colorType="literal"
                                     xType="ordinal"
                                     yDomain={[yDomain.min, yDomain.max]}>
                    <VerticalGridLines/>
                    <HorizontalGridLines/>
                    <XAxis/>
                    <YAxis/>
                    {value && <Hint value={value}/>}
                    <VerticalBarSeries
                        data={myData}
                        onValueMouseOver={v => setValue( v)}
                        onSeriesMouseOut={v => setValue(false)}
                    />
                </FlexibleWidthXYPlot>
            </div>
        )
}